import { Type } from "@sinclair/typebox";
import { IdSchema, Sha256Schema, TimestampSchema } from "./shared.js";
const AccessClaimsBaseSchema = {
    issuer: Type.Literal("RNAVoyager"),
    tokenId: IdSchema,
    identityId: IdSchema,
    sessionId: IdSchema,
    generation: Type.Integer({ minimum: 0 }),
    targetDigest: Sha256Schema,
    issuedAt: TimestampSchema,
    expiresAt: TimestampSchema,
};
function accessClaimsVariant(audience, purpose, requestDigest) {
    return Type.Object({
        ...AccessClaimsBaseSchema,
        audience: Type.Literal(audience),
        purpose: Type.Literal(purpose),
        ...(requestDigest === "required"
            ? { requestDigest: Sha256Schema }
            : requestDigest === "optional"
                ? { requestDigest: Type.Optional(Sha256Schema) }
                : {}),
    }, { additionalProperties: false });
}
const ArtifactAccessClaimsSchema = Type.Object({
    ...AccessClaimsBaseSchema,
    audience: Type.Literal("artifact-stream"),
    purpose: Type.Literal("artifact-read"),
    // requestDigest 绑定当前传输请求；下列两项独立绑定授权该读取的 ActionGrant。
    requestDigest: Sha256Schema,
    actionGrantId: IdSchema,
    actionRequestDigest: Sha256Schema,
    inputManifestDigest: Type.Optional(Sha256Schema),
}, { additionalProperties: false });
const ActionBoundProviderSearchAccessClaimsSchema = Type.Object({
    ...AccessClaimsBaseSchema,
    audience: Type.Literal("model-proxy"),
    purpose: Type.Literal("web-search"),
    requestDigest: Sha256Schema,
    actionGrantId: IdSchema,
    actionRequestDigest: Sha256Schema,
}, { additionalProperties: false });
const ActionBoundRuntimeAccessClaimsSchema = Type.Object({
    ...AccessClaimsBaseSchema,
    audience: Type.Literal("runtime-broker"),
    purpose: Type.Literal("runtime-operation"),
    requestDigest: Sha256Schema,
    actionGrantId: IdSchema,
    actionRequestDigest: Sha256Schema,
}, { additionalProperties: false });
// purpose、audience 与请求摘要是否存在属于线协议本身，不能只依赖签发端的条件分支。
export const AccessClaimsSchema = Type.Union([
    accessClaimsVariant("model-proxy", "model-decision", "required"),
    ActionBoundProviderSearchAccessClaimsSchema,
    accessClaimsVariant("runtime-broker", "runtime-operation", "required"),
    ActionBoundRuntimeAccessClaimsSchema,
    ArtifactAccessClaimsSchema,
]);
export const AccessRevocationSchema = Type.Object({
    tokenId: IdSchema,
    identityId: IdSchema,
    sessionId: IdSchema,
    revokedAt: TimestampSchema,
}, { additionalProperties: false });
export const AccessMessageBodySchema = Type.Union([
    Type.Object({ kind: Type.Literal("claims"), value: AccessClaimsSchema }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("revocation"), value: AccessRevocationSchema }, { additionalProperties: false }),
]);
//# sourceMappingURL=access.js.map